export class Position {
    positionId: number;
    name: string;
    subordinatePositionId: number;
    employeeName: string;
    employeeEmail: string;
    allStores: boolean;
    catDetJobId: number;
    active: boolean;
    catDetName: string;
    catId: number;
    catDetJobName: string;
    catDetCountryId: number;
    totalStores: number;
    organizationId: string;
}
